export default function BoxText({children}){
    return <>
     <p className="bg-gray-100 mt-8 px-4 py-3 font-Outfit font-medium text-base text-textColor ">
        {children}
     </p>
    </>
}